import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useBlockEnvironment } from '@zillow/cms-blocks/BlockEnvironment';
import PropertySearch from '@zillow/property-search';
import React, { useState } from 'react';
import ErrorBox from './ErrorBox.js';
import { PROPERTY_SEARCH_CONFIG_VALUES, sendInteractionSubmitEvent, FSBO_POSTING_URL_PATH } from './FSBOPropertySearch.utils.js';
import SearchInputWithButton from './SearchInputWithButton.js';

var FSBOPropertySearch = function FSBOPropertySearch(_ref) {
  var _PROPERTY_SEARCH_CONF2;
  var id = _ref.id;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    addressSelected = _useState2[0],
    setaddressSelected = _useState2[1];
  var _useBlockEnvironment = useBlockEnvironment(),
    _useBlockEnvironment$ = _useBlockEnvironment.environment,
    environment = _useBlockEnvironment$ === void 0 ? 'prod' : _useBlockEnvironment$;
  var buildResultsUrl = function buildResultsUrl(address, latitude, longitude) {
    var _PROPERTY_SEARCH_CONF;
    var encodedAddress = encodeURI(address) + ("&cid=" + Date.now()) + ("&claimType=Ownership&latitude=" + latitude + "&listingType=ForSale&longitude=" + longitude);
    var baseUrl = ((_PROPERTY_SEARCH_CONF = PROPERTY_SEARCH_CONFIG_VALUES[environment]) === null || _PROPERTY_SEARCH_CONF === void 0 ? void 0 : _PROPERTY_SEARCH_CONF['origin']) || PROPERTY_SEARCH_CONFIG_VALUES.test.origin;
    return baseUrl + FSBO_POSTING_URL_PATH + encodedAddress;
  };
  var handleAddressSelect = function handleAddressSelect(params) {
    if (params !== null && params !== void 0 && params.address) {
      setaddressSelected(params.address);
      var redirectUrl = buildResultsUrl(params.address, params.lat, params.lng);
      sendInteractionSubmitEvent(redirectUrl, id);
      window.open(redirectUrl, '_blank');
      return redirectUrl;
    }
    console.error('No results found for search');
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id || ''
  }, /*#__PURE__*/React.createElement(PropertySearch, {
    renderInput: function renderInput(props) {
      return SearchInputWithButton(Object.assign({
        handleAddressSelect: handleAddressSelect,
        addressSelected: addressSelected,
        options: props.options
      }, props));
    },
    addressAutocompleteUrl: ((_PROPERTY_SEARCH_CONF2 = PROPERTY_SEARCH_CONFIG_VALUES[environment]) === null || _PROPERTY_SEARCH_CONF2 === void 0 ? void 0 : _PROPERTY_SEARCH_CONF2['addressAutocompleteURL']) || PROPERTY_SEARCH_CONFIG_VALUES.test.addressAutocompleteURL,
    renderEmptyState: null,
    onSubmit: handleAddressSelect,
    renderError: ErrorBox
  }));
};
var FSBOPropertySearch$1 = FSBOPropertySearch;

export { FSBOPropertySearch$1 as default };
